import { useAppSelector } from 'src/store';
import { getAppRoutesAvailability } from 'src/routes/state/routesSelector';
import { useLocation } from 'react-router-dom';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { tableRouteSettings } from 'src/app/tables/Tables';
import { FeatureType } from 'src/shared/types';
import useFeature from 'src/shared/hooks/useFeature';
import { NestedSidebarMenuSubItem } from './NestedSidebarMenuItem';

const useTablesMenuItem = (): NestedSidebarMenuSubItem | null => {
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const navigate = useAppNavigation();
    const { pathname } = useLocation();
    const { hasFeature } = useFeature();
    const isHabitatInsightsProject = hasFeature({ feature: FeatureType.HLCA });
    const isEDnaProject = hasFeature({ feature: FeatureType.EDNA });

    if (!appRoutesAvailability.tables) {
        return null;
    }

    const subItems = Object.values(tableRouteSettings)
        .map(route => {
            const isHabitatInsightsMetrics = route.name === tableRouteSettings.habitatInsightsMetrics.name;
            const isSampleMetrics = route.name === tableRouteSettings.sampleMetrics.name;

            if (isHabitatInsightsMetrics && isHabitatInsightsProject) {
                return {
                    title: route.name,
                    testId: `${route.name.toLowerCase().replace(/\s+/g, '-')}-menu-item`,
                    onClick: navigate.toHabitatInsightsMetricsTable,
                    isActive: pathname.includes('/tables' + route.path),
                };
            }

            if (isSampleMetrics && (isEDnaProject || !isHabitatInsightsProject)) {
                return {
                    title: route.name,
                    testId: `${route.name.toLowerCase().replace(/\s+/g, '-')}-menu-item`,
                    onClick: navigate.toSampleMetricsTable,
                    isActive: pathname.includes('/tables' + route.path),
                };
            }
            return null;
        })
        .filter((item): item is NonNullable<typeof item> => Boolean(item));

    return {
        title: 'Tables',
        testId: 'tables-menu-button',
        subItems,
    };
};

export default useTablesMenuItem;
